import React, { Fragment } from 'react';
import {
  Button,
  Grid,
  Theme,
  Typography,
  withStyles,
  Table,
  TableBody,
  TableRow,
  TableHead,
  Tooltip,
  IconButton,
  Fab,
  Link,
  TextField,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { orange } from '@material-ui/core/colors';
import BodyCell from 'components/BodyCell';
import HeaderRow from 'components/HeaderRow';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { PRIMARY_COLOR } from 'constants/colors';

interface Props {
  candidateHistorysFDW: JobExperienceModel[];
  feedbackEmployer: FeedbackEmployerModel;
  setCandidateHistorysFDW: React.Dispatch<React.SetStateAction<JobExperienceModel[]>>;
  setFeedbackEmployer: React.Dispatch<React.SetStateAction<FeedbackEmployerModel>>;
  onAddHistory: React.FormEventHandler;
}

const useStyles = makeStyles((theme: Theme) => ({
  defaultText: {
    fontWeight: 500,
    marginRight: theme.spacing(-5)
  },
  textPasExisting: {
    position: 'relative',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)'
  },
  contentGrid: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(2),
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(0)
  },
  controlDiv: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2)
  },
  cancelButton: {
    marginRight: theme.spacing(3)
  },
  marginAddEmployment: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  checkBoxIcon: {
    fontSize: '16px'
  }
}));

const CandidateHistoryForm: React.FC<Props> = props => {
  const classes = useStyles(props);

  const icon = <CheckBoxOutlineBlankIcon className={classes.checkBoxIcon} />;
  const checkedIcon = <CheckBoxIcon className={classes.checkBoxIcon} />;

  const { candidateHistorysFDW, setCandidateHistorysFDW } = props;
  const { feedbackEmployer, setFeedbackEmployer } = props;

  const { onAddHistory } = props;

  return (
    <form noValidate>
      <Grid className={classes.contentGrid}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant='subtitle2'>Employment History (Maximum 4)</Typography>
          </Grid>
        </Grid>
        <Table>
          <TableHead>
            <HeaderRow
              headers={[
                { label: 'Country', pL: '10px', pR: '10px', verticalAlign: 'top' },
                { label: 'Employer', pL: '10px', pR: '10px', verticalAlign: 'top' },
                { label: 'Work Duties', pL: '10px', pR: '10px', verticalAlign: 'top' },
                { label: 'Remark ', pL: '10px', pR: '10px', verticalAlign: 'top' },
                { label: 'Year', pL: '10px', pR: '10px', verticalAlign: 'top' },
                { label: 'Action', pL: '10px', pR: '10px', verticalAlign: 'top' }
              ]}
            />
          </TableHead>
          <TableBody>
            {candidateHistorysFDW.map((history, index) => (
              <TableRow key={index}>
                <BodyCell pL='0px' pR='0px' cellWidth='5%' align='left' verticalAlign='top'>{history.country}</BodyCell>
                <BodyCell pL='0px' pR='0px' cellWidth='5%' align='left' verticalAlign='top'>{history.employer}</BodyCell>
                <BodyCell pL='0px' pR='0px' cellWidth='5%' align='left' verticalAlign='top'>
                  <Typography variant='body1' style={{ whiteSpace: 'pre-line' }}>
                    {history.workDuties}
                  </Typography>
                </BodyCell>
                <BodyCell pL='0px' pR='0px' cellWidth='5%' align='left' verticalAlign='top'>
                  <Typography variant='body1' style={{ whiteSpace: 'pre-line' }}>
                    {history.remarks}
                  </Typography>
                </BodyCell>
                <BodyCell pL='0px' pR='0px' cellWidth='5%' align='left' verticalAlign='top'>
                  {history.dateFrom} - {history.dateTo}
                </BodyCell>
                <BodyCell pL='0px' pR='0px' cellWidth='5%' align='left' verticalAlign='top'>
                  <Tooltip title='Delete' placement='left'>
                    <IconButton size='small'>
                      <DeleteIcon fontSize='small' color='primary' />
                    </IconButton>
                  </Tooltip>
                </BodyCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Grid container item justify='center' xs={12} sm={12} md={12} lg={12} xl={12} className={classes.controlDiv}>
          {candidateHistorysFDW.length < 4 && (
            <Fragment>
              <Typography className={classes.defaultText} color='primary'>
                <Link href='#' onClick={onAddHistory} color='primary'>
                  Add Employment
                </Link>
              </Typography>
            </Fragment>
          )}
        </Grid>

        {/* <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant='subtitle2'>Feedback From Previous Employer in Singapore</Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <TextField
              variant='outlined'
              margin='normal'
              fullWidth
              id='employer1'
              label='Employer 1'
              value={feedbackEmployer.employer1}
              onChange={event => setFeedbackEmployer({...feedbackEmployer, employer1: event.target.value })}
              autoComplete='off'
              InputLabelProps={{
                shrink: true
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant='outlined'
              margin='normal'
              fullWidth
              id='feedback1'
              label='Feedback 1'
              value={feedbackEmployer.feedback1}
              onChange={event => setFeedbackEmployer({...feedbackEmployer, feedback1: event.target.value })}
              autoComplete='off'
              InputLabelProps={{
                shrink: true
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant='outlined'
              margin='normal'
              fullWidth
              id='employer2'
              label='Employer 2'
              value={feedbackEmployer.employer2}
              onChange={event => setFeedbackEmployer({...feedbackEmployer, employer2: event.target.value })}
              autoComplete='off'
              InputLabelProps={{
                shrink: true
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant='outlined'
              margin='normal'
              fullWidth
              id='feedback2'
              label='Feedback 2'
              value={feedbackEmployer.feedback2}
              onChange={event => setFeedbackEmployer({...feedbackEmployer, feedback2: event.target.value })}
              autoComplete='off'
              InputLabelProps={{
                shrink: true
              }}
            />
          </Grid>
        </Grid> */}
        {/* <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant='subtitle2'>Availability of FDW to be Interviewed by Prospective Employer</Typography>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  icon={icon}
                  id='interview'
                  onClick={() => setFeedbackEmployer({...feedbackEmployer, interview: feedbackEmployer.interview ? false : true })}
                  checked={feedbackEmployer.interview}
                  checkedIcon={checkedIcon}
                  color='primary'
                />
              }
              label='FDW is not available for interview'
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  icon={icon}
                  id='phone'
                  onClick={() => setFeedbackEmployer({...feedbackEmployer, phone: feedbackEmployer.phone ? false : true })}
                  checked={feedbackEmployer.phone}
                  checkedIcon={checkedIcon}
                  color='primary'
                />
              }
              label='FDW  can be interviewed by phone'
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  icon={icon}
                  id='videoConference'
                  onClick={() => setFeedbackEmployer({...feedbackEmployer, videoConference: feedbackEmployer.videoConference ? false : true })}
                  checked={feedbackEmployer.videoConference}
                  checkedIcon={checkedIcon}
                  color='primary'
                />
              }
              label='FDW can be interviewed by video-conference'
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  icon={icon}
                  checked={feedbackEmployer.person}
                  id='person'
                  onClick={() => setFeedbackEmployer({...feedbackEmployer, person: feedbackEmployer.person ? false : true })}
                  checkedIcon={checkedIcon}
                  color='primary'
                />
              }
              label='FDW  can be interviewed in person'
            />
          </Grid>
        </Grid> */}
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              variant='outlined'
              margin='normal'
              fullWidth
              multiline
              rows='4'
              id='remarks'
              label='Remarks'
              value={feedbackEmployer.remarks}
              onChange={event => setFeedbackEmployer({ ...feedbackEmployer, remarks: event.target.value })}
              autoComplete='off'
              InputLabelProps={{
                shrink: true
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default CandidateHistoryForm;
